// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"4ee349c6","224":"6694e93e","404":"fd0741b5","464":"e08054f3","500":"cf3bd723","580":"cd580366"}[chunkId] + ".chunk.js";
};